import React, { useState, useEffect } from 'react';
import { Grid, TextField, Switch, FormControlLabel } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

const CrewSelector = (props) => {
  const { crews = [], classes, state, setState } = props;

  const [overrideEnabled, setOverrideEnabled] = useState(false);
  // const [state, setState] = useState({
  //   irrigationCrew: props.irrigationCrew || null,
  //   irrigationCrewOverride: null,
  // });
  console.log('Crew Selector...', state)

  useEffect(() => {
    if (state?.irrigationCrewOverride?._id) {
      setOverrideEnabled(true)
    } else {
      setOverrideEnabled(false)
    }
  }, [state])

  const handleOverrideToggle = (event) => {
    setOverrideEnabled(event.target.checked);
  };

  const handleCrewChange = (event, value) => {
    setState((prev) => ({ ...prev, irrigationCrew: value }));
  };

  const handleirrigationCrewOverrideChange = (event, value) => {
    setState((prev) => ({ ...prev, irrigationCrewOverride: value }));
  };

  const getOptionLabel = (option) =>
    `${option.name} ${option.foremanName ? `(${option.foremanName})` : ''}`;

  return (
    <Grid container spacing={2}>
      {/* Display Current Assigned Crew (Disabled) */}
      <Grid item xs={12} lg={12} className={classes.gridItem}>
        <Autocomplete
          id="crew"
          options={crews}
          getOptionLabel={getOptionLabel}
          value={state.irrigationCrew}
          onChange={handleCrewChange}
          disabled
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Assigned Crew"
              fullWidth
            />
          )}
        />
      </Grid>

      {/* Override Toggle */}
      <Grid item xs={12} lg={12}>
        <FormControlLabel
          control={
            <Switch
              checked={overrideEnabled}
              onChange={handleOverrideToggle}
              color="primary"
            />
          }
          label="Override Irrigation Crew"
        />
      </Grid>

      {/* Override Crew Autocomplete */}
      {overrideEnabled && (
        <Grid item xs={12} lg={12} className={classes.gridItem}>
          <Autocomplete
            id="override-crew"
            options={crews}
            getOptionLabel={getOptionLabel}
            value={state.irrigationCrewOverride}
            onChange={handleirrigationCrewOverrideChange}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Override Crew"
                fullWidth
              />
            )}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default CrewSelector;
